(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var main = document.getElementById('MainContent');
  if (!main || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = main.querySelectorAll(':scope > .shopify-section');
  if (!sections.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
  );

  var vh = window.innerHeight || document.documentElement.clientHeight;
  sections.forEach(function (s) {
    // Opt-out: full-bleed dark sections flashed the white page background during the reveal (the
    // translateY offset + opacity fade exposed it as a line at the top). Let them opt out with
    // [data-reveal-skip] so they stay solid.
    if (s.querySelector('[data-reveal-skip]')) return;
    // At/above the fold → leave visible (no load flash). Below the fold → hide + reveal on scroll.
    if (s.getBoundingClientRect().top < vh * 0.9) return;
    s.classList.add('reveal-init');
    io.observe(s);
  });

  // Safety net: never leave a section permanently hidden. If the observer hasn't revealed one
  // after a while (e.g. it sits where it can't cross the trigger threshold), reveal it anyway.
  // Below-fold sections aren't visible yet, so revealing them early is imperceptible.
  setTimeout(function () {
    main.querySelectorAll('.reveal-init:not(.is-revealed)').forEach(function (s) {
      s.classList.add('is-revealed');
    });
  }, 8000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
